import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-edit-product-multimodal-quantity',
  templateUrl: './dialog-edit-product-multimodal-quantity.component.html',
  styleUrls: ['./dialog-edit-product-multimodal-quantity.component.scss']
})
export class DialogEditProductMultimodalQuantityComponent {
  constructor(
    public dialogRef: MatDialogRef<DialogEditProductMultimodalQuantityComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}
